import { isEmpty } from 'lodash';

export const mergeAccountOptions = (availableOptions = [], rulesetDetail) => {
  if (isEmpty(rulesetDetail?.accountLivestreams)) {
    return availableOptions;
  }

  const currentlySelectedAccounts = [];

  rulesetDetail?.accountLivestreams?.forEach((account) => {
    currentlySelectedAccounts?.push({
      id: account?.id,
      ecommerce: { name: account?.ecommerce },
      name: account?.name,
    });
  });

  return [...availableOptions, ...currentlySelectedAccounts];
};
